import { useTranslation } from "react-i18next";
import DeveloperNav2ParamsPanel from "components/control/settings/DeveloperNav2ParamsPanel";
import DeveloperNavBehaviorTreePanel from "components/control/settings/DeveloperNavBehaviorTreePanel";
import DeveloperNavLogsPanel from "components/control/settings/DeveloperNavLogsPanel";
import DeveloperWebRTCPanel from "components/control/settings/DeveloperWebRTCPanel";

const DeveloperSettingsPanel: React.FC = () => {
    const { t } = useTranslation("settings");

    return (
        <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col">
            <div className="shrink-0 border-b border-black80 pb-4">
                <p className="text-h4 font-semibold text-white">{t("developer.title")}</p>
            </div>
            <DeveloperNavLogsPanel />
            <DeveloperNav2ParamsPanel />
            <DeveloperNavBehaviorTreePanel />
            <DeveloperWebRTCPanel />
        </div>
    );
};

export default DeveloperSettingsPanel;
